import {Provider} from '@oilstone/container';
import Validator from "@/services/resources/validator";

export default new Provider().register(() => {
    Validator.setBaseUrl(process.env.VUE_APP_API_URL);
});
